// extracted by mini-css-extract-plugin
module.exports = {"main_services":"MainServices_main_services__CG7Ex","button":"MainServices_button__xbe57","main_services__services_title":"MainServices_main_services__services_title__3_QRY"};